import { useTheme } from "@mui/material"

function useStyles() {
    const { breakpoints } = useTheme()
    return {
        container: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            paddingTop: '30px',
            paddingBottom: '2px',
        },
        body: ({ detail, existData }: { detail: boolean; existData?:boolean }) => ({
            padding: existData ? '0px 510px 2px 2px' : '0px',
            width: '100%',
            height: '100%',
            display: 'flex',
            gap: 3,
            [breakpoints.down('xl')]: {
                padding: '0px 50px 0px 2px',
            },
            ...(!detail && existData) && {
                padding: '0px 510px 0px 2px',
            },
        }),
        detail: {
            padding: 3,
            margin: '0px',
            width: '450px',
            height: '100%',
            position: 'fixed',
            right: '0px'
        }
    }
}

export { useStyles }